export enum LeadStatus {
  NEW = "New",
  CONTACTED = "Contacted",
  CONVERTED = "Converted",
  NURTURE = "Nurture",
  COLD = "Cold",
}
